module.exports = "<div *ngFor=\"let routeDetail of routeDetailList\">\n  <app-route-info-item [routeDetail]=\"routeDetail\" [hasProject]=\"hasProject\"></app-route-info-item>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/route-detail/components/route-info/route-info.component.html
// module id = 1444
// module chunks = 0